<template>
  <div class="page">
    <div class="layout">
      <el-row>
        <el-col :span="24">
          <div class="page-title">評估列表</div>
        </el-col>
      </el-row>
      <div class="page-box">
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column prop="gradeName" label="年級" align="center">
          </el-table-column>
          <el-table-column label="中文" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                size="medium"
                v-if="adminUserInfoRoleId !== teacherRoleId"
                @click="onEditButton(setRow(row.assessments, 0))"
                >編輯</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(setRow(row.assessments, 0))"
                >詳情</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="ENG" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                size="medium"
                v-if="adminUserInfoRoleId !== teacherRoleId"
                @click="onEditButton(setRow(row.assessments, 1))"
                >編輯</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(setRow(row.assessments, 1))"
                >詳情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="formLabelAlign._page"
      :limit.sync="formLabelAlign._limit"
      @pagination="getAssessments"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import { getAssessments } from "@/api/assessment";
export default {
  components: { Pagination },
  data() {
    return {
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      formLabelAlign: {
        orderNoLike: null,
        orderDate: null,
        userNo: null,
        status: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      tableData: [],
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getAssessments();
  },
  methods: {
    setRow(row, lang) {
      let newRow = row.filter((v) => {
        return v.lang == lang;
      })[0].id;
      return newRow;
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = this.underline(column.prop) + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = this.underline(column.prop) + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getAssessments();
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if(key == '_page'){
          this.formLabelAlign[key] = 1
        }
        if(key == '_limit'){
          this.formLabelAlign[key] = 50
        }
      })
      this.getAssessments();
    },
    onSearch() {
      this.getAssessments();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    onEditButton(id) {
      let path = `/evaluate/${id}/edit`;
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/evaluate/${id}`;
      this.resolveRouter(path)
    },

    onAlterButton(id) {
      this.orderId = id;
      this.centerDialogVisible = true;
    },
    getAssessments() {
      let formLabelAlign = {
        orderBy: this.formLabelAlign.orderBy,
      };
      getAssessments(formLabelAlign).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-box {
  background-color: #fff;
}
.button-el-el {
  margin-top: 23px;
}
</style>